import React from "react";
import { withFormik, Form } from "formik";
import * as Yup from "yup";
import { Label, Button, ModalFooter } from "reactstrap";
import { FormattedMessage, useIntl } from "react-intl";
import { toast } from "react-toastify";
import axios from "../../services/api/api";
import Select from "react-select";
import { TOAST_CONFIG } from "../../Utilities/toastConfig";

const AddTeachersToClassForm = (props) => {
  const intl = useIntl();
  const { values, errors, touched, isSubmitting, dismissModal } = props;

  const handleChange = (selected) => {
    values.selectedTeacherIds = selected.map((t) => t.id);
  };

  const getFilteredTeachers = () => {
    var teachers = [];
    values.teachers.forEach((t) => {
      if (values.existingTeachers.findIndex((et) => et.id === t.id) === -1) {
        teachers.push(t);
      }
    });
    return teachers;
  };

  return (
    <div className="col-12 col-sm-12">
      <Form>
        <Label>
          <FormattedMessage id="SelectOneOrMoreTeachers" />
        </Label>
        <Select
          placeholder={intl.formatMessage({ id: "ChooseTeacherPlaceholder" })}
          className={
            errors.selectedTeacherIds &&
            touched.selectedTeacherIds &&
            "is-invalid"
          }
          isMulti
          noOptionsMessage={() => intl.formatMessage({ id: "NoSelectableTeachersInClass" })}
          onChange={(selected) => handleChange(selected)}
          options={getFilteredTeachers().map((option) => ({
            ...option,
            label: option.name,
            value: option.id,
            clearableValue: true,
          }))}
        />
        {errors.selectedTeacherIds && touched.selectedTeacherIds && (
          <div className="invalid-feedback">{errors.selectedTeacherIds}</div>
        )}
        <ModalFooter>
          <Button
            outline
            color="secondary"
            type="button"
            onClick={dismissModal}
          >
            <FormattedMessage id="Cancel" />
          </Button>
          <Button type="submit" outline color="primary" disabled={isSubmitting}>
            {isSubmitting ? (
              <>
                <FormattedMessage id="Wait" />
              </>
            ) : (
              <>
                <FormattedMessage id="Add" />
              </>
            )}
          </Button>
        </ModalFooter>
      </Form>
    </div>
  );
};

const FormikForm = withFormik({
  mapPropsToValues: (props) => ({
    classId: props.classId,
    teachers: props.teachers,
    existingTeachers: props.existingTeachers,
    selectedTeacherIds: [],
  }),

  validationSchema: Yup.object().shape({
    selectedTeacherIds: Yup.array().min(
      1,
      <FormattedMessage id="Views.Admin.AddTeacherToClassForm.Error.SelectTeachers" />
    ),
  }),

  handleSubmit(values, { props, resetForm, setSubmitting }) {
    axios
      .post(
        `/AddTeachersToClass?teacherIds=${values.selectedTeacherIds.join(
          "&teacherIds="
        )}&classId=${values.classId}`
      )
      .then((response) => {
        toast.success(
          <FormattedMessage id="Views.Admin.AddTeacherToClassForm.Error.Success" />,
          TOAST_CONFIG
        );
        resetForm();
        props.loadTeachers();
        props.reloadAllTeachers();
        props.dismissModal();
      })
      .catch((err) => {
        toast.error(err.response.data, TOAST_CONFIG);
      });
    setSubmitting(false);
  },
})(AddTeachersToClassForm);

export default FormikForm;
